module.exports = __webpack_public_path__ + "static/red-bag2-866086f8b929962b8d78de7385871835.png";